import React from 'react';
import { TypedMemo } from '../../../../../common/types';
import type { DateRedo } from './useDateRedo';
import { useDateRedoDialog } from './useDateRedoDialog';
import { DateRedoBanner } from './DateRedoBanner';
import { DateRedoDialog } from './DateRedoDialog';
import { BeforeReleaseGroup } from './BeforeReleaseGroup';

interface DateRedoPanelProps {
  accountId: number;
  catalogItemUuid: string;
  redo: DateRedo;
  /** The largest `etaSec` of the kit assets that are being made now, or null. */
  etaSec?: number | null;
}

/**
 * The banner, the confirm dialog and the "Before release" group of "Redo the kit with the new
 * release date", at the top of the Kit and the Posts tab of a release. The group shows the
 * pre-save files with the old date after the release day (option A): they are not made again.
 */
const DateRedoPanelComponent: React.FC<DateRedoPanelProps> = ({ accountId, catalogItemUuid, redo, etaSec }) => {
  const dialog = useDateRedoDialog({ accountId, catalogItemUuid });
  return (
    <>
      <DateRedoBanner redo={redo} onRedo={dialog.open} etaSec={etaSec} />
      {redo.state?.released === true && (
        <BeforeReleaseGroup items={redo.beforeRelease} newDateLabel={redo.state.newDateLabel} />
      )}
      <DateRedoDialog model={dialog} />
    </>
  );
};

export const DateRedoPanel = TypedMemo(DateRedoPanelComponent);
